/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectPlusIcon16Solid = forwardRef('CommentRectPlusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v6a2.5 2.5 0 0 1-2.5 2.5H8.25l-3.695 2.463A1 1 0 0 1 3 14.633V12.95a2.5 2.5 0 0 1-2-2.45v-6Zm7.875.25a.875.875 0 1 0-1.75 0v1.875H5.25a.875.875 0 1 0 0 1.75h1.875v1.875a.875.875 0 0 0 1.75 0V8.375h1.875a.875.875 0 0 0 0-1.75H8.875V4.75Z" })));
});
